"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ACTIONS_ROOT = void 0;
const ACTIONS_ROOT = exports.ACTIONS_ROOT = 'actions-root';
